import { EclassWorkerEnum } from '@app/core/models/eclass-worker.enum';
import { Checker } from '@app/shared/utils';
import { AppState } from '@app/store/app.state';
import { Header } from '../../utils/postable';
import { FilterControlEnum, FilterForm } from '../posts-filter-bar/filter-bar';

export const InboxFilter = (state: AppState) => ({
  status: [],
  filters: filters(state),
});

export const InboxHeader: Header = {
  plural: 'eclass.agenda.filtros.caixa-entrada',
  singular: 'eclass.agenda.filtros.caixa-entrada',
  icon: 'icon-inbox',
  worker: EclassWorkerEnum.All,
};

function filters(store: AppState): FilterForm {
  const filters = [FilterControlEnum.Group, FilterControlEnum.Subject];
  if (Checker.isEmployee(store.funcao_padrao)) {
    filters.push(FilterControlEnum.Level, FilterControlEnum.Grade);
    if (!Checker.isTeacher(store.funcao_padrao)) {
      filters.push(FilterControlEnum.Author);
    }
  }
  return {
    fixed: [FilterControlEnum.Group, FilterControlEnum.Subject],
    filters,
  };
}
